import React from "react";
import {
  StyledDialog,
  DialogContent,
  IconWrapper,
  SuccessTitle,
  SuccessDescription,
  DialogFooter,
  AddMoreButton,
  GoTopmsButton,
  UsersContainer,
  UserName,
  UserDescription
} from "./PromptShareSuccessModal.styled";
import { CheckCircleOutline } from "@mui/icons-material";

const PromptShareSuccessModal = ({ isOpen, onClose, usersCount, onAddMore, onGoToPromptManagement, users = [], onReload }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleAddMore = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onReload) {
      await onReload();
    }
    onAddMore();
  };

  const handleGoToPromptManagement = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onGoToPromptManagement();
  };

  return (
    <StyledDialog 
      open={isOpen} 
      onClose={onClose}
      onClick={handleClick}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            maxWidth: '100%',
            margin: '16px'
          }
        }
      }}
    >
      <DialogContent onClick={handleClick}>
        <IconWrapper>
          <CheckCircleOutline color="success" sx={{ fontSize: 32 }} data-testid="success-icon"  />
        </IconWrapper>
        <SuccessTitle data-testid="success-modal">
          Sharing completed successfully
        </SuccessTitle>
        <SuccessDescription>
          {usersCount} users have been added to this prompt.
        </SuccessDescription>
        {users.length > 0 && (
          <UsersContainer>
            {users.map((user, index) => (
              <UserName key={index} index={index}>
                {user.name}
                <UserDescription>
                  {user.email || "email"} &nbsp; | &nbsp; {user.role?.name || "role"}
                </UserDescription>
              </UserName>
            ))}
          </UsersContainer>
        )}
      </DialogContent>
      <DialogFooter>
        <AddMoreButton onClick={handleAddMore}>
          Add more users
        </AddMoreButton>
        <GoTopmsButton onClick={handleGoToPromptManagement}>
         Go to Prompt Management
        </GoTopmsButton>
      </DialogFooter>
    </StyledDialog>
  );
};

export default PromptShareSuccessModal;